// extracted by mini-css-extract-plugin
module.exports = {"region-library-wrapper":"_1VxuBkodN1","add-button":"ZFagZMUN_Z","base-input":"_2hWSiL7Ar7","base-select":"lsRT8uXJk2"};